module.exports = __webpack_public_path__ + "img/blurred-bg.bf3c7405.png";